var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrescriptionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.917 26.25a1.167 1.167 0 01-1.167 1.167H5.25a1.167 1.167 0 01-1.167-1.167V1.75A1.167 1.167 0 015.25.583h11.184c.31 0 .606.123.825.342l6.316 6.316c.219.22.342.516.342.825V26.25z",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.917.688v5.729a1.167 1.167 0 001.166 1.166h5.729M7.583 21.583h12.834M7.583 23.917h12.834M18.083 12.833a.583.583 0 00-.583-.583h-1.75V10.5a.583.583 0 00-.583-.583h-2.334a.583.583 0 00-.583.583v1.75H10.5a.583.583 0 00-.583.583v2.334a.584.584 0 00.583.583h1.75v1.75a.583.583 0 00.583.583h2.334a.583.583 0 00.583-.583v-1.75h1.75a.584.584 0 00.583-.583v-2.334z",
    stroke: "#fff",
    strokeWidth: 1.167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgPrescriptionIcon;